export default __webpack_public_path__ + "static/media/Sindh Bank Cheque.32f5de2c.jpg";